module.exports = __webpack_public_path__ + "img/nature-52.553bc8a9.jpg";